import React from "react";

import WithAppLayout from "../../../components/WithAppLayout";
import PageTableWithSearch from "../../../components/PageTableWithSearch/PageTableWithSearch";

import { recruitersColumns } from "../../../components/PageTableWithSearch/tableDataHelper";
import WithQuery from "../../../components/WithQuery";
import { GET_RECRUITER_USERS_QUERY } from "../../../graphql/agencies";
import { LoadingIndicator } from "../../../components/LoadingIndicator";
import __ from "../../../helpers/translations";

function AllRecruitersPageInner({
  data,
  error,
  loading,
  refetch,
  currentUser,
}) {
  if (loading) {
    return <LoadingIndicator />;
  }

  return (
    <PageTableWithSearch
      title={__("Admins", currentUser?.agency?.type)}
      tableId="agency-all-recruiters"
      columns={recruitersColumns(currentUser, refetch)}
      data={data?.getRecruiterUsers || []}
    />
  );
}

function PageComponent({ currentUser, children }) {
  return WithQuery(AllRecruitersPageInner, GET_RECRUITER_USERS_QUERY, null, {
    currentUser,
    children,
  })();
}

export default WithAppLayout(PageComponent);
